export { default as ic_info } from "../../template/list/ic_info.svg?react";
export { default as ic_emotion_share } from "../../template/list/ic_emotion_share.svg?react";
export { default as ic_indi_share } from "../../template/list/ic_indi_share.svg?react";
export { default as ic_team_share } from "../../template/list/ic_team_share.svg?react";
export { default as ic_communication } from "../../template/list/ic_communication.svg?react";
export { default as ic_improve_problem } from "../../template/list/ic_improve_problem.svg?react";
export { default as ic_share_history } from "../../template/list/ic_share_history.svg?react";
export { default as ic_pin } from "../../template/list/ic_pin.svg?react";

export { default as ic_time_check } from "../../template/list/ic_time_check.svg?react";
